import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import './i18next/i18n';

import './index.scss';

import store from './app/store';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

// Filter out defaultProps warning
// eslint-disable-next-line no-console
const originalError = console.error;
// eslint-disable-next-line no-console
console.error = (...args) => {
  if (args[0].includes('defaultProps')) return;
  originalError.call(console, ...args);
};

const isLandingPage = process.env.REACT_APP_BUILD_TARGET === 'landing';

const App = isLandingPage ? null : lazy(() => import('./App'));
const About = isLandingPage
  ? lazy(() => import('./components/About/About'))
  : null;

if (!isLandingPage) {
  import('@emoji-mart/data').then(emojiData => {
    import('emoji-mart').then(emojiMart => {
      emojiMart.init({ data: emojiData.default });
    });
  });
}

function Root() {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <Suspense fallback={<span className="site-loader" />}>
            {isLandingPage ? <About /> : <App />}
          </Suspense>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Root />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();
